import { axios } from '@/plugins/axios';
import { Agent } from '@/models/agent';

export class AgentService {
  private endpoint: string;

  constructor() {
    this.endpoint = 'v1/agents/';
  }

  async createAgent(agent: Agent) {
    return axios
      .post<Agent>(`${this.endpoint}`, agent)
      .then(({ data }) => data);
  }

  async fetchAgents() {
    return axios.get<Agent[]>(`${this.endpoint}`).then(({ data }) => data);
  }

  async fetchAgent(id: number) {
    return axios.get<Agent>(`${this.endpoint}${id}/`).then(({ data }) => data);
  }

  async updateAgent(agent: Agent) {
    return axios
      .put<Agent>(`${this.endpoint}${agent.id}/`, agent)
      .then(({ data }) => data);
  }

  async deleteAgent(id: number) {
    return axios.delete(`${this.endpoint}${id}/`);
  }
}
